// From vue-class-component docs:
// https://github.com/vuejs/vue-class-component#adding-custom-hooks

import Component from 'vue-class-component'

// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
])



// WEBPACK FOOTER //
// ./src/class-component-hooks.js